import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showHelpbox } from '../../actions/HelpboxAction';
import WidgetActions from './widgetActions';
import { makeFullScreen, ResizeElements } from '../../utils/helper';

class WidgetOptions extends Component {
  toggleInfoBox(type) {
    this.props.showHelpbox({
      type,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  onFullscreenClick(type) {
    try {
      ResizeElements(type);
    } catch (err) {
      console.log('err', err);
    }
    makeFullScreen();
  }

  render() {
    return (
      <div>
        <WidgetActions
          infoIdText={this.props.infoIdText}
          expandIdText={this.props.expandIdText}
          onInfoClick={this.toggleInfoBox.bind(this)}
          onExpandClick={this.props.onExpandClick.bind(this)}
          onFullscreenClick={this.onFullscreenClick}
          hideExpand={this.props.hideExpand}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showHelpbox,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(WidgetOptions);
